module.exports = __webpack_public_path__ + "img/olivia.c36deb94.jpeg";